export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCoFhwzZk3EG8vAXrDPCqwNM7pkqw_1kCY',
    authDomain: 'am-cham.firebaseapp.com',
    databaseURL: 'https://am-cham.firebaseio.com',
    projectId: 'am-cham',
    storageBucket: 'am-cham.appspot.com',
    messagingSenderId: '484951773738',
    appId: '1:484951773738:web:e831321a243f20b00ae953',
    measurementId: 'G-MTHSFH61QF'
  },
  firebase_vapid: 'BJ_vHghc2Z6WdGr0XNB8eY2t29huWS9X5_nh1ldRiqnP09UcjrLug768NWDiSeQKxNTT135k-bOPkART0WE28XY'
};
